import { BiCheck, BiX } from "react-icons/bi";
import styled from "styled-components";
import * as yup from "yup";

import { formatCurrency } from "util/numbers";

import { Account } from "api/types/Account";
import {
  ButtonType,
  ColorSlider,
  DisplayInput,
  FieldContainer,
  FlexButton,
  FlexButtonContainer,
  TextInput,
} from "components/ui/forms";
import { useMemo } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
const Label = styled.div`
  width: 30%;
  font-size: 0.6rem;
  padding: 0 1rem;
`;

const validation = yup.object().shape({
  name: yup.string().required(),
  color: yup.string().required(),
  initialBalance: yup.number().optional(),
  account_number: yup.string().optional(),
});

type Props = {
  data: Partial<Account>;
  onColorChange: (color: string) => void;
  onNameChange: (name: string) => void;
  onBalanceClick: () => void;
  onAccountNumberChange: (accountNumber: string) => void;
  onSubmit: (data: Partial<Account>) => void;
  onCancel: () => void;
};

const AccountForm = ({
  data = {},
  onColorChange,
  onNameChange,
  onBalanceClick,
  onSubmit,
  onAccountNumberChange,
  onCancel,
}: Props) => {
  const handleSubmit = () => {
    try {
      const validatedData = validation.validateSync(data, {
        abortEarly: false,
      });
      onSubmit(validatedData);
    } catch (errors) {
      console.log(errors);
      // setErrors(getKeyedValidationErrors(errors))
    }
  };

  const canSubmit = useMemo(() => {
    try {
      validation.validateSync(data);
    } catch (errors) {
      return false;
    }
    return true;
  }, [data]);

  const { name, color, initialBalance, account_number } = data;

  return (
    <Container>
      <div>
        <FieldContainer>
          <TextInput
            label="Name ..."
            placeholder="Name ..."
            value={name}
            onChange={onNameChange}
          />
        </FieldContainer>

        <FieldContainer>
          <TextInput
            label="Account number ..."
            placeholder="Account number ..."
            value={account_number}
            onChange={onAccountNumberChange}
          />
        </FieldContainer>

        <FieldContainer>
          <DisplayInput
            name="initialBalance"
            label="Initial balance"
            placeholder=""
            onClick={onBalanceClick}
            value={initialBalance || 0}
            display={formatCurrency(initialBalance || 0)}
          />
        </FieldContainer>

        <FieldContainer>
          <ColorSlider label="Colour" onChange={onColorChange} value={color} />
        </FieldContainer>
      </div>

      <FlexButtonContainer>
        <FlexButton onClick={onCancel} type={ButtonType.Cancel}>
          <BiX />
        </FlexButton>
        <FlexButton
          onClick={handleSubmit}
          disabled={!canSubmit}
          type={ButtonType.Accept}
        >
          <BiCheck />
        </FlexButton>
      </FlexButtonContainer>
    </Container>
  );
};

export default AccountForm;
